module.exports = __webpack_public_path__ + "img/vx.e1461510.svg";